// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ToolFilledSvg from "@fishx/icons-svg/es/asn/ToolFilled";
import FishxIcon from '../components/FishxIcon';

var ToolFilled = function ToolFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ToolFilledSvg
  }));
};

ToolFilled.displayName = 'ToolFilled';
export default React.forwardRef(ToolFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ToolFilled.js
// module id = 4270
// module chunks = 0